// extracted by mini-css-extract-plugin
module.exports =  {"jobCardLocation":"JobLocation-module_jobCardLocation_e0a49","locationIcon":"JobLocation-module_locationIcon_ce1b8","locationText":"JobLocation-module_locationText_fcd4f"};